import { FC, useState } from 'react';
import { IconColor, IconType, Props } from './helpers';
import FlatButton from '../flat-button';

interface DoneIconProps extends Props {
  label?: string;
  doneLabel?: string;
}

const DoneIcon: FC<DoneIconProps> = ({
  name,
  color,
  onClick,
  className,
  label = '',
  doneLabel = '',
}) => {
  const [config, setConfig] = useState<{ name: IconType; color?: IconColor; label: string }>({
    name,
    color: color || undefined,
    label,
  });

  const handleClick = () => {
    onClick?.();

    setConfig({ name: 'done', color: 'success', label: doneLabel || label });
    setTimeout(() => {
      setConfig({ name, color: color || undefined, label });
    }, 3000);
  };

  return (
    <FlatButton
      onClick={handleClick}
      label={config.label}
      icon={config.name}
      className={className}
      color={config.color}
    />
  );
};

export default DoneIcon;
